module.exports = __webpack_public_path__ + "resources/img/img_appen_data2_m_jp.1e9831897b1a1630b9f55cdd2fcc219e.png";